(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form').submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.get('localization-form') || customElements.define('localization-form', LocalizationForm); // eslint-disable-line

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerHeight = document.querySelector('.header-wrapper');
      this.filters = document.getElementById('main-collection-filters');
      this.quickSearch = document.querySelector('quick-search');

      this.lastScrollTop = 0;     
      this.scrollingDown = true;

      this.onScrollHandler  = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResizeHandler, false);
      window.addEventListener('orientationchange', this.onResizeHandler, false);

      /* find header dimensions the old way (not using IntersectionObserver) */
      let data  = this.header.getBoundingClientRect();
      this.top  = data.top + window.scrollY ;
      this.bottom = data.bottom + window.scrollY;
      this.height = data.height;

      /* measure first, then stick, otherwise may get no top */
      this.header.classList.add('shopify-section-header-sticky');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('orientationchange', this.onResizeHandler);
    }
    /* used observer to find out header size -- why did they do it this way? */
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        /* ??? this must be an error -- because it's dimensions of how target intersects with root(window) 
          will return all zeroes if we're not at the top of the page and target is not fixed/sticky 
          could have been used if we were using observer to track current position?

        this.headerBounds = entries[0].intersectionRect;
        */
        this.headerBounds = entries[0].boundingClientRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onResize(){
      if( this.filters && this.state == 'shrunk' ){
        this.shrink();
      }
    }

    onScroll() {
      const scrollTop =  window.pageYOffset || document.documentElement.scrollTop;

      this.scrollingDown = scrollTop > this.lastScrollTop;
      this.lastScrollTop = scrollTop;

      if(this.state == 'transition') {
        return;
      }

      else if (this.scrollingDown && this.state != 'shrunk'){
        if( scrollTop > this.top + this.height/2 ) { /* scrolled down past half of the header, let's shrink */
          requestAnimationFrame( this.shrink.bind(this) );
        }
      } else if(!this.scrollingDown && this.state != 'grown' ){  /* scrolling up past half of the header */
        if( scrollTop < this.top + this.height/2 ) {   /* if higher than half of the header */
          requestAnimationFrame( this.reset.bind(this) );
        }
      }
    }

    /* make a pause in calculations while CSS transitions are in progress */
    transitionTo( s ){
      this.state= 'transition';
      window.setTimeout(() => {
        this.state = s;         
      }, 300 );  /* transition delay set in CSS */
    }
    /* used in original theme to hide and reveal header on scroll. not used since we have it always visible 
    hide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    */

    shrink( timestamp ) {
      /* timestamp is passed by requestAnimationFrame */
      this.header.classList.add('shrink');

      if( this.filters ) {
         /* wait for CSS transitions on header to finish. 
            Filters own top is made low (in CSS) to create a reveal animation for fast scrollers, 
            otherwise we may have ugly jumps due to shrinking header  */
        window.setTimeout( ()=>{
          let headerBottom = this.headerHeight.offsetHeight - 5;
          this.filters.style.top = `${headerBottom}px`;
          document.querySelector('.boost-pfs-filter-left-col').style.top = headerBottom + this.filters.offsetHeight +'px';
          document.querySelector('body').classList.add('shrink-header'); 
        }, 300 );
      }
      this.transitionTo( 'shrunk' );
    }

    reset() {
      //this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shrink');

      if( this.filters ){
        this.filters.style.top='';
        document.querySelector('body').classList.remove('shrink-header');
      }
      this.transitionTo('grown');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }


  document.querySelectorAll('.menu-drawer__menu-item').forEach(item => {
    item.addEventListener('click', event => {
      //handle click
      var menuLvl = event.target.getAttribute('data-level');
      
      if (menuLvl == 1) {
        event.target.closest('.menu-drawer__navigation').scroll(0, 0);
        event.target.closest('.menu-drawer__navigation').classList.add('noScroll');
      } else if (menuLvl == 2) {
        event.target.closest('.menu-drawer__inner-submenu').scroll(0, 0);
        event.target.closest('.menu-drawer__inner-submenu').classList.add('noScroll');
      }
      //console.log(menuLvl)
    })
  });


  document.querySelectorAll('.menu-drawer__close-button span').forEach(item => {
    item.addEventListener('click', event => {
      //handle click
      var menuLvl = event.target.parentElement.getAttribute('data-level');
      if (menuLvl == 1) {
        event.target.closest('.menu-drawer__navigation').classList.remove('noScroll');
      } else if (menuLvl == 2) {
        event.target.closest('.menu-drawer__inner-submenu').classList.remove('noScroll');
      }
      //console.log(event.target)
    })
  })

  customElements.get('sticky-header') || customElements.define('sticky-header', StickyHeader); // eslint-disable-line



  document.addEventListener('DOMContentLoaded', () => {
    let el = document.querySelector('.search-modal__content.visually-hidden');
    if ( el )
      el.classList.remove('visually-hidden');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
    document.querySelector('.blog-click').addEventListener('click', () => {
      document.querySelector('.blog-info-drawer').classList.add('active');
      document.body.classList.remove('open-drawer');
    });
    document.querySelector('.blog-width-info__close').addEventListener('click', () => {
      document.querySelector('.blog-info-drawer').classList.remove('active');
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.get('cart-note') || customElements.define('cart-note', CartNote); // eslint-disable-line

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
  
      loadScript();
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.get('product-recommendations') || customElements.define('product-recommendations', ProductRecommendations); // eslint-disable-line

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  class SmoothScrolling {
    constructor() {
      this.selectors = {
        forms: 'form',
        button: '.button'
      };
    }

    handleClick(e) {
        if (e.target.tagName !== 'A') return;
        if ((e.target.href && e.target.href.indexOf('#') != -1) && ((e.target.pathname == location.pathname) || ('/' + e.target.pathname == location.pathname)) && (e.target.search == location.search)) {
          this.scrollAnchors(e, e.target);
        }
    }

    scrollAnchors(e, respond = null) {
        function distanceToTop(el) { 
          return Math.floor(el.getBoundingClientRect().top); 
        }
        e.preventDefault();
        const targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');

        // Validate target ID
        if (!targetID || !targetID.startsWith('#')) {
          return;
        }

        const targetAnchor = document.querySelector(targetID);
        if (!targetAnchor) return;
        const originalTop = distanceToTop(targetAnchor) - 140;
        window.scrollBy({ top: originalTop, left: 0, behavior: 'smooth' });
        const checkIfDone = setInterval(function() {
          const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
          if (distanceToTop(targetAnchor) === 0 || atBottom) {
            targetAnchor.tabIndex = '-1';
            targetAnchor.focus();
            if ('history' in window) {
               window.history.pushState('', '', targetID);
              } else {
                window.location = targetID;
            }
          clearInterval(checkIfDone);
        }
      }, 100);
    }

    initEventListeners() {
      document.addEventListener('click', this.handleClick.bind(this));
    }

    init() {
      this.initEventListeners();
    }
  }

  document.addEventListener('DOMContentLoaded', () => new SmoothScrolling().init());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-fullscreen-video"] && !Shopify.designMode) return;
  try {
    

  let videoIframe,
      playButton,
      stopButton;

  const videoInstances = document.querySelectorAll('.full-screen-video_wrapper');

  videoInstances.forEach((el) => {
    videoIframe = el.querySelector('.iframe iframe');
    videoIframe.setAttribute('id', 'youtube');

    playButton = el.querySelector('.YtCustomPlayButton');
    stopButton = el.querySelector('.yt-closed');

    if (playButton) {
      playButton.setAttribute('data-src', videoIframe.src + '?autoplay=1&showinfo=0&modestbranding=1&controls=0&rel=0');

      playButton.addEventListener('click', (e) => {
        stopVideos();

        const video = e.currentTarget.closest('.full-screen-video_wrapper');
        videoIframe = video.querySelector('.iframe iframe');

        videoIframe.setAttribute('src', e.currentTarget.getAttribute('data-src'));
      });
    }
    
    if (stopButton) {
      stopButton.addEventListener('click', (e) => {
        stopVideos();
      });
    }
  });

  function stopVideos() {
    videoInstances.forEach((video) => {
      videoIframe = video.querySelector('.iframe iframe');

      if (videoIframe) {
        videoIframe.setAttribute('src', '');
      }
    });
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-large-banner-cta"] && !Shopify.designMode) return;
  try {
    

  const ytIframe = document.querySelector('.iframe iframe');
  const playButton = document.querySelector('#YtCustomPlayButton');
  const stopButton = document.querySelector('.yt-closed');
  let ytIframeSource = document.querySelector('.iframe iframe').src;

  ytIframe.setAttribute('id', 'youtube');
  playButton.addEventListener('click', (e) => {
    ytIframe.setAttribute('src', ytIframeSource + '?autoplay=1&showinfo=0&modestbranding=1&controls=0&rel=0');
  });

  stopButton.addEventListener('click', (e) => {
    ytIframe.setAttribute('src', ytIframeSource + '?autoplay=0');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-static-left-tabbing"] && !Shopify.designMode) return;
  try {
    
    
  let i, tabContent, tablinks, tabItem, tabContentTitle;
    tablinks = document.querySelectorAll('.tab .tablinks');
    tablinks.forEach(elem => {elem.addEventListener('click', activeTabScreen );});

    tabContent = document.querySelectorAll('.section-left-tabbing .tabcontent');
    tabContent.forEach(function (elem, i) { 
      tabContentTitle = elem.querySelector('.title').textContent.toLowerCase();
      elem.setAttribute('id', tabContentTitle);
      if(i != 0){
        elem.classList.add('visually-hidden');
      }
    });

    function activeTabScreen(evt) {
      tablinks = document.getElementsByClassName('tablinks');
      tablinks.forEach(elem => {
        tabItem = elem.textContent.toLowerCase();
        elem.setAttribute('id', tabItem);
        elem.className = elem.className.replace(' active', '');
      });

      evt.currentTarget.classList.add('active');
      const activeId = evt.target.getAttribute('id');

      tabContent.forEach(elem => {
        if(activeId == elem.getAttribute('id')){
          elem.classList.remove('visually-hidden');
        } else {
          elem.classList.add('visually-hidden');
        }
      })
      
    }


  } catch(e) { console.error(e); }
})();
})();
